import vuetify from './vuetify';
import router from '../router';
import { i18nVue } from 'laravel-vue-i18n'
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from "@sentry/tracing";
import type {App} from 'vue';
import helper from "@/pcm/plugins/helper";
import validation from "@/pcm/plugins/validation";
import toast from "@/pcm/plugins/toast";
import translations from "@/pcm/plugins/translations";
import authorization from "@/pcm/plugins/authorization/authorization";
import authenticationPlugin from "@/pcm/plugins/authentication/authenticationPlugin";
import store from "@/pcm/store/store";
import betterDevTools from '@/pcm/plugins/better-devtools';

export function registerPlugins(app: App) {
    app
        .use(i18nVue, {
            resolve: async (lang: string) => {
                const response = await window.api.get('translations/'+lang);

                return {
                    default: response.data,
                };
            }
        })
        .use(store)
        .use(translations)
        .use(helper)
        .use(authorization)
        .use(authenticationPlugin)
        .use(validation)
        .use(toast)
        .use(vuetify)
        .use(router)
        .use(betterDevTools);
}
